module.exports = __webpack_public_path__ + "static/media/bris-glace.2d9914f7.svg";